module.exports = __webpack_public_path__ + "static/media/turnItOn.bb47f02a.png";